import { Component } from '@angular/core';
import { ActivationEnd, Event, Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { LightspeedAuthService } from '../services/lightspeed-auth.service';
import { environment } from '../../environments/environment';
import { StatusService } from '../services/status.service';

@Component({
  selector: 'app-content',
  imports: [],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  standalone: true,
})
export class ContentComponent {
  constructor(
    private readonly _notificationService: NotificationService,
    private readonly _lightSpeedAuthService: LightspeedAuthService,
    private readonly _loadStatus: StatusService,
    public router: Router,
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof ActivationEnd) {
        const code = event.snapshot.queryParams['code'];
        if (code !== null && code !== undefined) {
          this.processCode(code);
        }
      }
    });
  }

  public onGrantAccessButtonClick(): void {
    const client_id: string = 'VVFy4Ljbmwcc';
    const scopes: string[] = [
      'employee:register_read',
      'employee:inventory_read',
      'employee:admin_shops',
    ];
    const scopeParam = encodeURIComponent(scopes.join(' '));
    const redirectUri =
      environment.lightspeedRedirectUri ||
      `${window.location.origin}/dashboard`;
    const redirectParam = encodeURIComponent(redirectUri);
    const state = Math.random().toString(36).slice(2);

    const url: string =
      `https://cloud.lightspeedapp.com/auth/oauth/authorize` +
      `?response_type=code` +
      `&client_id=${client_id}` +
      `&redirect_uri=${redirectParam}` +
      `&scope=${scopeParam}` +
      `&state=${state}`;

    // Navigate in the same tab to avoid popup blockers
    window.location.assign(url);
  }

  public processCode(code: string) {
    const decodedUri: string = decodeURI(code);
    this._loadStatus.isLoading.next(true);

    this._lightSpeedAuthService.saveCode(decodedUri).subscribe({
      next: (data) => {
        this._notificationService.removeAllNotifications();
        this._notificationService.showSuccessMessage(
          'Circana Reporting App has been authorized.',
        );
      },
      error: (err) => {
        this._loadStatus.isLoading.next(false);
        console.error('error', err);
        let errorMsg: string = 'An error has occurred, please try again.';
        if (err.status == 0) {
          errorMsg = 'System not available. please try again';
        } else {
          errorMsg = err?.error?.title;
        }
        this._notificationService.showErrorMessage(errorMsg);
      },
    });
  }
}
